import { render, staticRenderFns } from "./postFacebook.vue?vue&type=template&id=386456d7&"
import script from "./postFacebook.vue?vue&type=script&lang=js&"
export * from "./postFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports